// src/unAuth/components/NavBar.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import "./NavBar.css";

const NavBar = () => (
  <nav className="navbar-container" aria-label="Main navigation">
    <a href="#hero" className="navbar-left navbar-brand-link" aria-label="Timestampgn home">
      <FontAwesomeIcon icon={faClock} className="navbar-brand-icon" />
      <span className="navbar-brand">
        <span className="brand-highlight">Timestamp</span>
        <span className="brand-suffix">Gn</span>
      </span>
    </a>
    <div className="navbar-right">
      <ul className="navbar-menu">
        <li>
          <a href="#how-it-works">How it works</a>
        </li>
        <li>
          <a href="#creator-tips">Tips</a>
        </li>
        <li>
          <a href="#faq">FAQ</a>
        </li>
        <li>
          <a href="#generator">Generator</a>
        </li>
      </ul>
    </div>
  </nav>
);

export default NavBar;
